<template lang="pug">
    el-dialog(title="预约人员管理", width="95%",:visible.sync='visible' :append-to-body="true" :modal-append-to-body='false' @close="closeForm()")
        div
            el-form(:inline='true', :model='coachList'  size='mini' label-position='right' label-width='75px' label-suffix=':')
                el-row(:span='24')
                 el-col(:md='4' :sm='8')
                    el-form-item(label='教练姓名')
                        font {{coachList.pxCoachSimpleVO.coachName}}
                 el-col(:md='4' :sm='8')
                    el-form-item(label='手机号码')
                        font {{coachList.pxCoachSimpleVO.phone}}
                 el-col(:md='4' :sm='8')
                    el-form-item(label='等级' label-position='right')
                        font {{coachList.pxCoachSimpleVO.leve}}
                 el-col(:md='4' :sm='8')
                    el-form-item(label='级别' label-position='right')
                        font {{coachList.pxCoachSimpleVO.coachLevel}}
                 el-col(:md='4' :sm='8')
                    el-form-item(label='性别' label-position='right')
                        font {{coachList.pxCoachSimpleVO.sex===0?'男':coachList.pxCoachSimpleVO.sex===1?'女':''}}
                 el-col(:md='4' :sm='8')
                    el-form-item(label='授课时数' label-position='right')
                        font {{coachList.pxCoachSimpleVO.classHours}}
                el-row(:span='24')
                 el-col(:md='4' :sm='8')
                    el-form-item(label='课程名称')
                        font {{coachList.pxSubscribeCoachCourseVO.name}}
                 el-col(:md='4' :sm='8')
                    el-form-item(label='班级人数')
                        font {{coachList.pxSubscribeCoachCourseVO.count}}
                 el-col(:md='4' :sm='8')
                    el-form-item(label='会员等级' label-position='right')
                        font {{coachList.pxSubscribeCoachCourseVO.memberLevel}}
                 el-col(:md='4' :sm='8')
                    el-form-item(label='课时费' label-position='right')
                        font {{coachList.pxSubscribeCoachCourseVO.hourFee}} 元/人
        <el-card shadow="never">
            <div slot="header" class="clearfix">
                <span class="fontStyle">预约人员</span>
            </div>
            <div style="margin-bottom:10px">
                <el-button type="primary" @click='clickRefund'>退款</el-button>
                <el-button @click='ListExport' type="primary">名单导出</el-button>
            </div>
            el-table(:data="siteDetailData" v-loading='dataListLoading' style="width: 100%" height="250"  border @selection-change='selectionSitePriceDetailHandle')
                el-table-column(type='selection', header-align='center', align='center', width='50')
                el-table-column(type="index",header-align='center',align='center',label='序号', width='50' )
                el-table-column(prop='memberName',header-align='center',align='center',label='姓名' )
                el-table-column(prop='memberMobile',header-align='center',align='center',label='账号' )
                el-table-column(prop='memberType',header-align='center',align='center',label='会员类型' )
                    template(slot-scope="scope")
                            font(v-if='scope.row.memberType === 1')
                                span() &nbsp; 注册会员
                            font(v-if='scope.row.memberType === 2')
                                span() &nbsp; 初级会员
                            font(v-if='scope.row.memberType === 3')
                                span() &nbsp; 荣誉会员
                el-table-column(prop='memberLevel',header-align='center',align='center',label='会员等级' )
                el-table-column(prop='subscribeDateStr',header-align='center',align='center',label='日期' )
                el-table-column(prop='subscribeTime',header-align='center',align='center',label='时间段' )
                el-table-column(prop='spaceName',header-align='center',align='center',label='场地' )
                el-table-column(prop='payStateName',header-align='center',align='center',label='状态' )
                    //- template(slot-scope="scope")
                    //-     font(v-if='scope.row.payState == -1')
                    //-         span.danger()
                    //-         span() &nbsp; 未审核
                    //-     font(v-if='scope.row.payState === 2')
                    //-         span.warning()
                    //-         span() &nbsp; 已拒绝
                    //-     font(v-if='scope.row.payState === 3')
                    //-         span.success()
                    //-         span() &nbsp; 已发布
                    //-     font(v-if='scope.row.payState === 4')
                    //-         span.warning()
                    //-         span() &nbsp; 报名中
                    //-     font(v-if='scope.row.payState === 5')
                    //-         span.warning()
                    //-         span() &nbsp; 报名结束
                    //-     font(v-if='scope.row.payState === 6' )
                    //-         span.warning()
                    //-         span() &nbsp; 已开训
                    //-     font(v-if='scope.row.payState === 7')
                    //-         span.warning()
                    //-         span() &nbsp; 已结束
                    //-     font(v-if='scope.row.payState === 8')
                    //-         span.warning()
                    //-         span() &nbsp; 已取消
                el-table-column(prop='amount',header-align='center',align='center',label='支付金额' )
                el-table-column(prop='refundRate',header-align='center',align='center',label='退款比例' )
                el-table-column(prop='refundAmount',header-align='center',align='center',label='退款金额' )
        </el-card>
        el-dialog(title="退款" :visible.sync='refundVisible' :append-to-body='true' :modal-append-to-body='false')
              el-form(:model="refundForm" ref="refundForm" style="padding:30px;")
                  el-row
                      el-col(:span="8")
                          div(style="float:right")
                            el-radio(v-model="radio" label="1" border) 按比例退款
                      el-col(:span="16")
                          el-form-item(prop="refundScale" label="：" style="display:inherit;")
                              el-input-number(:disabled="radio==1 ? false : true" v-model="refundForm.refundScale" :min=0 :max=100 )
                  el-row
                      el-col(:span="8")
                          div(style="float:right")
                              el-radio(v-model="radio" label="2" border) 按固定金额退款
                      el-col(:span="16")
                          el-form-item(prop="refundFee" label="：" style="display:inherit;")
                              el-input-number(:disabled="radio==2 ? false : true" v-model="refundForm.refundFee" :min=0 :max='refundFeeMax' :precision="2" )
                      el-col
                          el-input(v-model="refoundDescr" type="textarea" :rows=6 resize="none" placeholder="请输入退款原因")
              span.dialog-footer(slot="footer")
                  el-button(@click="comfirmRefundRee" type="primary"  :loading="refundBtn") 确 定
                  el-button(@click="refundVisible=false") 取 消
        span.dialog-footer(slot="footer")
            //- el-button(type="primary") 确 定
            el-button(@click="closeForm()") 返 回
</template>
<script>
import table from './table.js'
export default {
  name: 'ReserveUserManager',
  data () {
    return {
      table: {
        columns: table.columns,
        data: null,
        size: 'mini',
        stripe: true,
        border: true
      },
      refoundDescr: '', //退款原因
      refundVisible: false,
      dataListLoading: false,
      refundBtn: false,
      visible: false,
      nameFont: 40,
      ctRefundParmas: {},
      sitePriceDetailParams: {},
      siteDetailData: [],
      refundData: [],
      typeID: null,
      exportData: [],
      coachList: { coachName: '' },
      payRefund: null,
      refundForm: {},
      radio: undefined,
      loading: null,
      refundFeeMax: 0
    }
  },
  created () {
    // this.getMemberTypeList()
  },
  methods: {
    //退款弹窗事件
    clickRefund (btn, row) {
      // console.log(btn, row)
      console.log('退款按钮：', row)
      this.radio = undefined
      this.payRefund = {}
      this.refoundDescr = ''
      //支付状态(-1全部，0未支付,1支付中,2支付成功,3支付失败,4超时,5申请退款,6退款中,7退款成功,8退款失败,9支付已关闭，10退款已取消)
      //批量退款
      // this.payRefund = null
      //替补人员不需要退费操作
      if (this.enrollDataOneChange.length === 0) {
        this.$message.error('提示：请勾选要退费的人员！')
        return
      }
      console.log('勾选的退款人员', this.enrollDataOneChange)
      let feeFlag = false
      let feeInfo = ''
      let idArr = []
      this.refundFeeMax = parseFloat(
        this.enrollDataOneChange[0].amount
      ).toFixed(2)
      this.enrollDataOneChange.forEach((row) => {
        if (
          row.payState == 0 ||
          row.payState == 1 ||
          row.payState == 3 ||
          row.payState == 4
        ) {
          feeInfo = '提示：未缴费不能退款！'
          feeFlag = true
          return
        }
        if (row.payState == 5) {
          feeInfo = '提示：已发起退款申请！'
          feeFlag = true
          return
        }
        if (row.payState == 6 || row.payState === 8) {
          feeInfo = '提示：退款中！'
          feeFlag = true
          return
        }
        if (row.payState == 7) {
          feeInfo = '提示：已完成退款！'
          feeFlag = true
          return
        }
        idArr.push(row.id)
        //退款金额赋最大值
        if (this.refundFeeMax > parseFloat(row.amount).toFixed(2)) {
          this.refundFeeMax = parseFloat(row.amount).toFixed(2)
        }
      })
      if (feeFlag) {
        this.$message.error(feeInfo)
        return
      }
      console.log('已选退费人员id：', idArr)
      console.log('已选退费人员id：', idArr.join())
      // this.payRefund.placeOrderItemIds = idArr.join()
      this.payRefund.placeOrderItemIds = idArr
      this.refundFeeMax = parseFloat(this.refundFeeMax)
      if (this.refundFeeMax === 0) {
        //都是0元退款不弹窗直接退
        this.refundVisible = false
        this.refundForm.refundScale = 0
        this.refundForm.refundFee = 0
        this.submitRefund()
      } else {
        this.refundVisible = true
        this.refundForm.refundScale = undefined
        this.refundForm.refundFee = undefined
      }
    },
    //退款提交事件
    comfirmRefundRee () {
      console.log('退款信息：', this.refundForm)
      if (this.radio === undefined) {
        this.$message.error('请选择按比例或者固定金额退款!')
        return
      }
      if (this.radio == 1) {
        if (!this.refundForm.refundScale) {
          this.$message.error('请填写退款比例!')
          return
        } else {
          this.payRefund.refundScale = this.refundForm.refundScale
          this.payRefund.refundFee = undefined
          this.refundForm.refundFee = undefined
        }
      }
      if (this.radio == 2) {
        if (!this.refundForm.refundFee) {
          this.$message.error('请填写固定金额退款!')
          return
        } else {
          this.payRefund.refundFee = this.refundForm.refundFee
          this.payRefund.refundScale = undefined
          this.refundForm.refundScale = undefined
        }
      }
      if (this.refoundDescr === '') {
        this.$message.error('请填写退款原因!')
        return
      }
      this.payRefund.refoundDescr = this.refoundDescr //退款原因
      this.payRefund.refundFeeType = Number(this.radio) //退款费用类型 1、按比例退款 2、按固定金额退款
      this.submitRefund()
    },
    submitRefund () {
      if (this.refundFeeMax === 0) {
        if (!this.payRefund.refundFee) {
          this.payRefund.refundFee = 0
        }
        if (!this.payRefund.refundScale) {
          this.payRefund.refundScale = 0
        }
      }
      console.log('退款确定：', this.payRefund)
      this.refundBtn = true
      this.$http({
        url: this.$http.adornUrl(`/pxSubscribe/refund`),
        method: 'post',
        data: this.payRefund
      }).then((data) => {
        if (data && data.code === 0) {
          this.$message.success('操作成功！')
          this.refundVisible = false
          this.refundBtn = false
          this.datatypeList()
        } else {
          // alert(1)
          this.refundBtn = false
        }
      })
    },
    //   名单导出
    ListExport (id) {
      if (this.exportData.length === 0) {
        this.$message.info('没有要导出的数据!')
        return
      }
      let exportData = JSON.parse(JSON.stringify(this.exportData))

      for (let i of exportData) {
        i.memberType = i.memberType === 1 ? '注册会员' : i.memberType === 2 ? '初级会员' : i.memberType === 3 ? '初级会员' : ''
      }
      this.$export
        .excel({
          columns: this.table.columns,
          data: exportData,
          title: '预约人员名单'
        })
        .then(() => {
          this.$message.success('导出表格成功')
        })
    },
    // 教练信息获取
    dataformLIST (id) {
      this.$http({
        url: this.$http.adornUrl(`/pxSubscribe/info/` + id),
        method: 'get'
      }).then((data) => {
        if (data && data.code === 0) {
          this.coachList = data.data
          this.changeCity(data.data.pxCoachSimpleVO.id)
        }
      })
    },
    // 根据教练id获取教练详细信息
    changeCity (id) {
      let ids = id
      this.$http({
        url: this.$http.adornUrl(`/pxCoach/getId/` + ids),
        method: 'get'
      }).then((data) => {
        if (data && data.code === 0) {
          let coachForm = {
            // 教练基本信息
            id: data.bean.id,
            coachName: data.bean.name, // 教练姓名
            phone: data.bean.phone, // 手机号码
            leve: data.bean.leve, // 等级
            coachLevel: data.bean.coachLevel, // 级别
            sex: data.bean.sex, // 性别
            classNum: data.bean.classHours, // 授课时数
            coachQualifications: data.bean.intelligence, // 教练资质
            coachLabel: data.bean.label, // 教练标签
            imageUrl: data.bean.headPortrait,
            sportExperience: data.bean.sportsExperience,
            classHours: data.bean.classHours
          }
          this.coachList.pxCoachSimpleVO = coachForm
        }
      })
    },
    init (typeID) {
      this.visible = true
      this.typeID = typeID
      this.datatypeList()
      this.dataformLIST(this.typeID)
    },
    // 预约筛选名单获取
    datatypeList () {
      this.dataListLoading = true
      this.$http({
        url: this.$http.adornUrl(`/pxSubscribe/members/` + this.typeID),
        // url: this.$http.adornUrl(
        //   `/pxSubscribe/members/` + 'fc64ded63181e29f6501b75b54a4fa7f'
        // ),
        method: 'get'
      }).then((data) => {
        if (data && data.code === 0) {
          this.siteDetailData = data.data.rows
        } else {
          this.siteDetailData = []
        }
        this.dataListLoading = false
      })
    },
    closeForm () {
      this.visible = false
    },
    selectionSitePriceDetailHandle (val) {
      this.exportData = val
      this.enrollDataOneChange = val
    }
  }
}
</script>
<style scoped>
.fontStyle {
  font-weight: bold;
  font-size: 18px;
}
.width_ct {
  width: 50%;
}
.sel_width_ct,
.input_width_ct {
  width: 20% !important;
}
.son-container {
  flex-grow: 1;
  display: flex;
  margin-bottom: 20px;
}
.container {
  display: flex;
  justify-content: space-between;
}
</style>
